<template>
    <div class="d-flex">
        <div class="form-group">
            <label for="date_from">Date début</label>
            <datepicker lang="fr" v-model="dateFrom" input-class="form_control"></datepicker>
        </div>
        <div class="form-group ml-2">
            <label for="date_to">Date fin</label>
            <datepicker lang="fr" v-model="dateTo" input-class="form_control"></datepicker>
        </div>
    </div>
</template>
<script>
import {mapActions} from "vuex";

export default {
    name: 'DateFilter',
    watch: {
        dateFrom() {
            if (this.timeout) {
                clearTimeout(this.timeout)
            }

            this.timeout = setTimeout(this.loadAsyncData, 300)
        },
        dateTo() {
            if (this.timeout) {
                clearTimeout(this.timeout)
            }

            this.timeout = setTimeout(this.loadAsyncData, 300)
        },
    },
    computed: {
        dateFrom: {
            get() {
                return this.$store.state.order.date_from

            },
            set(value) {
                this.$store.commit('order/setDateFrom', value)
            }
        },
        dateTo: {
            get() {
                return this.$store.state.order.date_to
            },
            set(value) {
                this.$store.commit('order/setDateTo', value)
            }
        },
    },
    methods: {
        ...mapActions('order', [
            'getOrders',
        ]),
        loadAsyncData() {
            this.getOrders()
        },
    }
}
</script>
